// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-70945755] {\n  display: flex;\n}\n[data-v-70945755] .el-form-item__label {\n  width: 125px;\n}\n[data-v-70945755] .el-form-item__content {\n  display: flex;\n  align-items: center;\n}\n.mb20[data-v-70945755] {\n  margin-bottom: 20px;\n}\n.form-title[data-v-70945755] {\n  font-size: 16px;\n  height: 20px;\n  line-height: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
